export const loginHistoryTableSortEntityName = 'logins'

export const getLoginHistoryTableSortDefaultSorter = () =>
  ({
    name: 'active',
    direction: 'desc',
  }) as const
